
import Swiper from "swiper";
import { Navigation, Autoplay, FreeMode } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function() {
    const speakersSliders = document.querySelectorAll('.speakers-slider');

    speakersSliders.forEach(container => {
        const swiperContainer = container.querySelector('.speakers-slider__swiper');
        const prevArrow = container.querySelector('.swiper-button-prev');
        const nextArrow = container.querySelector('.swiper-button-next');
        const pauseControl = container.querySelector('.speakers-slider__pause-button');
        const showMoreBtn = container.querySelector('.speakers-slider__show-more');
        const type = container.dataset.type || 'row';
        const speed = parseInt(container.dataset.carouselSpeed) || 3000;

        if (!swiperContainer) return;

        let swiper = null;
        const mobileQuery = window.matchMedia("(max-width: 1023px)");

        let pauseControlListener = null;
        let resizeListener = null;

        const checkSliderNeedsSliding = () => {
            if (!swiper) return false;

            const containerWidth = swiperContainer.offsetWidth;
            const slides = swiperContainer.querySelectorAll('.swiper-slide');
            let totalSlidesWidth = 0;

            slides.forEach(slide => {
                totalSlidesWidth += slide.offsetWidth;
            });

            const spaceBetween = swiper.params.spaceBetween || 20;
            totalSlidesWidth += (slides.length - 1) * spaceBetween;

            return totalSlidesWidth > containerWidth;
        };

        const initSwiper = () => {
            if (swiper) return;

            swiper = new Swiper(swiperContainer, {
                modules: [Navigation, Autoplay, FreeMode],
                slidesPerView: "auto",
                spaceBetween: 20,
                freeMode: {
                    enabled: true,
                    momentum: true,
                    momentumRatio: 0.5,
                    momentumBounce: false,
                    sticky: true
                },
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                },
                speed: speed,
                navigation: {
                    nextEl: nextArrow,
                    prevEl: prevArrow,
                },
                breakpoints: {

                    768: {
                        spaceBetween: 24
                    },
                    1024: {
                        spaceBetween: 30
                    }
                }
            });

            // Force swiper to recalculate after initialization
            setTimeout(() => {
                if (swiper) {
                    swiper.update();
                    setupPauseControl();
                }
            }, 100);
        };

        const destroySwiper = () => {
            if (swiper) {
                swiper.destroy(true, true);
                swiper = null;
            }
            // Clean up event listeners
            if (pauseControlListener && pauseControl) {
                pauseControl.removeEventListener('click', pauseControlListener);
                pauseControlListener = null;
            }
        };

        const setupPauseControl = () => {
            if (!pauseControl || !swiper) return;

            // Remove existing listener
            if (pauseControlListener) {
                pauseControl.removeEventListener('click', pauseControlListener);
            }

            const needsSliding = checkSliderNeedsSliding();

            if (!needsSliding) {
                pauseControl.style.display = 'none';
            } else {
                pauseControl.style.display = 'flex';

                // Create new listener
                pauseControlListener = function() {
                    if (swiper && swiper.autoplay.running) {
                        swiper.autoplay.stop();
                        pauseControl.classList.add('paused');
                    } else if (swiper) {
                        swiper.autoplay.start();
                        pauseControl.classList.remove('paused');
                    }
                };

                pauseControl.addEventListener('click', pauseControlListener);
            }
        };

        const setupGridShowMore = () => {
            if (type !== 'grid' || !showMoreBtn) return;

            const slides = swiperContainer.querySelectorAll('.swiper-slide');
            let isExpanded = false;

            const calculateVisibleSlides = () => {
                if (window.innerWidth < 1024) return slides.length;

                const slidesPerRow = Math.floor(swiperContainer.offsetWidth / 232);
                return slidesPerRow * 2;
            };

            const updateGridVisibility = () => {
                const visibleSlides = calculateVisibleSlides();

                if (window.innerWidth < 1024) {
                    slides.forEach(slide => {
                        slide.style.display = 'block';
                        slide.style.opacity = '1';
                        slide.style.transform = 'translateY(0)';
                    });
                    showMoreBtn.style.visibility = 'hidden';
                    return;
                }

                slides.forEach((slide, index) => {
                    if (index >= visibleSlides && !isExpanded) {
                        slide.style.opacity = '0';
                        slide.style.transform = 'translateY(20px)';
                        slide.style.transition = 'opacity 0.3s ease, transform 0.3s ease';

                        setTimeout(() => {
                            if (!isExpanded) slide.style.display = 'none';
                        }, 300);
                    } else {
                        slide.style.display = 'block';
                        slide.style.transition = 'opacity 0.3s ease, transform 0.3s ease';

                        setTimeout(() => {
                            slide.style.opacity = '1';
                            slide.style.transform = 'translateY(0)';
                        }, 10);
                    }
                });

                if (slides.length <= visibleSlides || isExpanded) {
                    showMoreBtn.style.visibility = 'hidden';
                } else {
                    showMoreBtn.style.visibility = 'visible';
                }
            };

            // Clean up existing resize listener
            if (resizeListener) {
                window.removeEventListener('resize', resizeListener);
            }

            resizeListener = () => updateGridVisibility();

            showMoreBtn.addEventListener('click', () => {
                isExpanded = !isExpanded;
                updateGridVisibility();
            });

            updateGridVisibility();
            window.addEventListener('resize', resizeListener);
        };

        const handleScreenChange = (e) => {
            if (type === 'row') {
                if (!swiper) initSwiper();
            } else if (type === 'grid') {
                if (e.matches) {
                    if (!swiper) initSwiper();
                    // Reset slide styles for mobile
                    setTimeout(() => {
                        const slides = swiperContainer.querySelectorAll('.swiper-slide');
                        slides.forEach(slide => {
                            slide.style.display = 'block';
                            slide.style.opacity = '1';
                            slide.style.transform = 'translateY(0)';
                        });
                    }, 150);
                } else {
                    destroySwiper();
                    setupGridShowMore();
                }
            }
        };

        handleScreenChange(mobileQuery);
        mobileQuery.addEventListener('change', handleScreenChange);

        // Single resize listener for pause control
        window.addEventListener('resize', () => {
            if (swiper && pauseControl) {
                // Force swiper to recalculate
                swiper.update();
                setTimeout(() => {
                    const needsSliding = checkSliderNeedsSliding();
                    pauseControl.style.display = needsSliding ? 'flex' : 'none';
                }, 100);
            }
        });
    });
});


function syncHeights() {
    const blocks = document.querySelectorAll('.speakers-element__fintua-speakers');

    blocks.forEach(block => {
        const left = block.querySelector('.speakers-element__fintua--left');
        const firstCard = block.querySelector('.speaker-card');

        if (left && firstCard) {
            left.style.height = firstCard.offsetHeight + 'px';
        }
    });
}

document.addEventListener("DOMContentLoaded", syncHeights);
window.addEventListener("load", syncHeights);
window.addEventListener("resize", syncHeights);

